import { z } from "zod"

const requiredErrorMessage = "Errors.required"

const createRequiredField = (message = requiredErrorMessage) =>
  z.string().min(1, message)

const requiredField = createRequiredField()

export { createRequiredField, requiredErrorMessage, requiredField }
